import { initTriBackground } from './_modules/background.js';
import { initBookFilter } from './_modules/books.js';


document.addEventListener('DOMContentLoaded', () => {
  initTriBackground();
  initBookFilter();
});

/* =====================================================================
スロットル
======================================================================== */
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

/* =====================================================================
スマホメニュー（右上ボタン）
======================================================================== */
const megaParents = document.querySelectorAll('#nav_megamenu .has_mega a');
const megaChildren = document.querySelectorAll('.s_megamenu');
const menuBtn = document.querySelector('.js-menuBtn');
// var openMenu = document.querySelector('.js-openMenu');
// var resizeMyTimer;

menuBtn.addEventListener('click', function() {
  // navs.forEach(function(element) {
  // 	element.classList.remove('is-On');
  // });
  if (document.body.classList.contains('is-menuOpen')) {
    document.body.classList.remove('is-menuOpen');
  } else {
    document.body.classList.add('is-menuOpen');
  }
  megaParents.forEach(item => {
    item.classList.remove('is-On');
  });
  megaChildren.forEach(item => {
    item.classList.remove('is-On');
  });
});


/* =====================================================================
メガメニュー
======================================================================== */
document.addEventListener('DOMContentLoaded', function() {
  megaParents.forEach(item => {
    item.addEventListener('click', function(event) {
      event.preventDefault();

      megaParents.forEach(item => {
        if (item === this) {
          item.classList.toggle('is-On');
        } else {
          item.classList.remove('is-On');
        }
      });

      const parentNav = this.parentElement;
      const dataNavValue = parentNav.getAttribute('data-nav');

      megaChildren.forEach(item => {
        const dataMenuValue = item.getAttribute('data-menu');
        if (dataNavValue === dataMenuValue) {
          item.classList.toggle('is-On');
        } else {
          item.classList.remove('is-On');
        }
      });
    });
  });
});

/* =====================================================================
ヘッダーのスクロール時の表示非表示
======================================================================== */

let timeoutId;
let lastScrollTop = 0;

// throttle を使ってスクロールイベントを間引きしながら実行する
window.addEventListener(
  'scroll',
  throttle(function() {
    // スクロールを停止して500ms後に終了とする
    clearTimeout(timeoutId);

    // 		timeoutId = setTimeout(function() {
    // 			document.body.classList.remove('is-Up');
    // 			document.body.classList.remove('is-Down');
    // 		}, 500);
    //
    // 		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //
    // 		if (scrollTop > lastScrollTop) {
    // 			//console.log("下方向にスクロール");
    // 			//document.body.classList.remove('is-Up');
    // 			document.body.classList.add('is-Down');
    // 		} else {
    // 			//console.log("上方向にスクロール");
    // 			document.body.classList.remove('is-Down');
    // 			//document.body.classList.add('is-Up');
    // 		}
    //
    // 		lastScrollTop = scrollTop;

    if (window.scrollY > 100) {
      document.body.classList.add('is-Move');
      toTop.classList.add('is-show');
    } else {
      document.body.classList.remove('is-Move');
      toTop.classList.remove('is-show');
    }
  }, 50)
); // 50ミリ秒ごとに処理を実行

/* =====================================================================
toTop
======================================================================== */

var toTop = document.getElementById('js-totop');

if (toTop) {
  toTop.addEventListener('click', function() {
    //alert("OK");
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // header.style.opacity = 0;
    // setTimeout(function() {
    // 	header.style.display = 'none';
    // }, 300);
  });
}

/* =====================================================================
スムーススクロール
======================================================================== */

document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    // クリックされたアンカーリンクのhref属性を取得
    const href = anchor.getAttribute('href');

    // href属性からパターンにマッチする部分を取得
    const match = href.match(/^(.+?)#(.+)$/);

    if (match) {
      const targetBefore = match[1]; // # より前の部分
      const targetId = match[2]; // # より後の部分

      // 同一ページ内の要素かどうかをチェック
      let isSamePage = window.location.pathname === targetBefore;

      if (isSamePage) {
        //alert("same");
        e.preventDefault(); // デフォルトの挙動を防ぐ

        // ヘッダーの高さを取得するなど、必要な調整を行う
        const headerHeight = document.querySelector('header').offsetHeight;

        // 取得した要素の位置を取得
        const target = document.getElementById(targetId);
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        // スクロールを実行
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      }
    } else {
      const match2 = href.match(/#(.+)$/);
      if (match2) {
        const targetId2 = match2[1];

        e.preventDefault(); // デフォルトの挙動を防ぐ

        // ヘッダーの高さを取得するなど、必要な調整を行う
        const headerHeight2 = document.querySelector('header').offsetHeight;

        // 取得した要素の位置を取得
        const target2 = document.getElementById(targetId2);
        const targetPosition2 = target2.getBoundingClientRect().top + window.pageYOffset - headerHeight2;

        // スクロールを実行
        window.scrollTo({
          top: targetPosition2,
          behavior: 'smooth',
        });
      }
    }
  });
});

/* =====================================================================
IntersectionObserver版 inView
======================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  // 監視対象となるすべての要素をまとめて取得
  const targets = document.querySelectorAll(
  '.dual_image, .jsFadeUp, .jsFadeDown, .jsFadeIn, .jsFadeFR, .jsFadeFL, .jsZoomIn, .jsMoveLine, .jsMoveLine2, .jsAnimeText, .jsShutter'
  );

  // IntersectionObserver を作成
  const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    // 要素がビューポート内に入ったら
    if (entry.isIntersecting) {
    entry.target.classList.add('isInview');
    obs.unobserve(entry.target); // 一度だけ反応させたい場合
    }
  });
  }, {
  root: null,        // ビューポート基準
  rootMargin: '0px', // 発火位置を調整する場合は '0px 0px -10%' などに変更可
  threshold: 0.1     // 10%見えたら発火
  });

  // 対象すべてを監視開始
  targets.forEach(el => observer.observe(el));
});
